import React from 'react';
import { TripsDataTable } from './trips/data-table';
import { tripColumns } from './trips/columns';

/**
 * Enhanced Trip Table component using shadcn/ui and TanStack Table
 * @param {Object} props - Component props
 * @param {Array} props.trips - Array of trip data
 * @param {Function} props.onTripClick - Callback function when trip row is clicked
 * @param {Object} props.pagination - Pagination object with page, totalPages, limit
 * @param {Function} props.onPageChange - Callback function for page changes
 * @param {boolean} props.loading - Loading state
 * @returns {JSX.Element} ShadcnTripTable component
 */
const ShadcnTripTable = ({ 
  trips, 
  onTripClick, 
  pagination, 
  onPageChange, 
  loading = false 
}) => {
  return (
    <TripsDataTable
      columns={tripColumns}
      data={trips}
      onTripClick={onTripClick}
      pagination={pagination}
      onPageChange={onPageChange}
      loading={loading}
    />
  );
};

export default ShadcnTripTable;
